import { IMPLEMENTATION_PLAN_NAMES, STAGES_NAMES } from 'components/BusinessToolForm/Sections/ImplementationPlan/utils/form';

import { ol, ul } from '../helpers';

const STAGES_INSTRUCTIONS = {
  [STAGES_NAMES.STAGE]: {
    name: 'План реалізації',
    instruction:
      'Відповідаючи на запитання щодо графіка реалізації проєкту, дотримуйтеся таких кроків:' +
      ol([
        'Окресліть ключові етапи — від концепції до запуску.',
        'Укажіть орієнтовну тривалість кожного етапу.',
        'Позначте, на якому етапі ви перебуваєте зараз.',
      ]),
    exampleOne: ul([
      'Концепція та дизайн: 6 місяців.',
      'Прототипування та тестування: 9 місяців.',
      'Налаштування виробництва: 3 місяці.',
      'Маркетинг та підготовка до запуску: 2 місяці.',
      'Наразі на етапі налаштування виробництва.',
    ]),
    exampleTwo: ul([
      'Концептуальний етап: 3 місяці.',
      'Дизайн і прототипування: 6 місяців.',
      'Тестування та ітерації: 4 місяці.',
      'Фіналізація та виробництво: 3 місяці.',
      'Наразі на етапі тестування та ітерацій.',
    ]),
  },
};

export const IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS = {
  [IMPLEMENTATION_PLAN_NAMES.STAGES]: STAGES_INSTRUCTIONS,
};

